import { CircularCounter } from "routes/sfg20-admin/plugins/system-info/common/components/CircularContainer"
import uniqolor from "uniqolor"

export function StatsOverviewItem({ item }) {
    const { color } = uniqolor(item.statistic.trimEnd(), {
        saturation: [65, 99],
        lightness: [65, 87],
    })
    const options = {}
    if (item.maxValue) {
        options.maxValue = item.maxValue
    }
    return <CircularCounter title={item.statistic} value={item.value} color={color} options={options} />
}
